import { VendorItemArray } from './vendor.item';
import { ISortable } from '../../helpers/sort';
import { SortItem } from '../../../app/models/ss-api/responses/member.dashboard.license.response';

export class Vendor {
    ID: number;
    DisplayName: string;
    Email: string;
    FirstName: string;
    LastName: string;
    IsActive: string;
    DateTimeCreated: Date;

    Items: VendorItemArray;

    public static FixDates(item: Vendor) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class VendorArray extends Array<Vendor> implements ISortable {

    public LastSort: SortItem;

    constructor(...items: Vendor[]) {
        super(...items);
        Object.setPrototypeOf(this, VendorArray.prototype);
    }

    public static FixDates(items: VendorArray) {
        items.forEach(x => Vendor.FixDates(x));
    }

}
